import React, { useState } from 'react';
import CtaBand from '../components/CtaBand';
import { PROJECTS } from '../constants/data';
import styles from './Projects.module.css';

// Benzersiz kategorileri çıkar
function getCategories(projects) {
  const map = new Map();
  projects.forEach(p => {
    if (!map.has(p.category)) map.set(p.category, p.categoryLabel);
  });
  return Array.from(map, ([value, label]) => ({ value, label }));
}

export default function Projects() {
  const categories = getCategories(PROJECTS);
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightbox, setLightbox] = useState(null);

  const filtered = activeFilter === 'all'
    ? PROJECTS
    : PROJECTS.filter(p => p.category === activeFilter);

  return (
    <main className="page-wrapper">
      {/* Page header */}
      <div className="page-header">
        <div className={styles.headerInner}>
          <span className="eyebrow">Tamamladığımız İşler</span>
          <h1>Projelerimiz</h1>
          <p className={styles.headerSub}>
            İstanbul ve çevre illerde tamamladığımız 850'yi aşkın projeden
            bir seçki. Her biri güvenlik standartlarına uygun olarak teslim edilmiştir.
          </p>
        </div>
      </div>

      {/* Filtre + Galeri */}
      <section className={styles.section}>
        <div className={styles.container}>

          {/* Filtre butonları */}
          <div className={styles.filters}>
            <button
              className={`${styles.filterBtn} ${activeFilter === 'all' ? styles.filterActive : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              Tümü ({PROJECTS.length})
            </button>
            {categories.map(c => (
              <button
                key={c.value}
                className={`${styles.filterBtn} ${activeFilter === c.value ? styles.filterActive : ''}`}
                onClick={() => setActiveFilter(c.value)}
              >
                {c.label} ({PROJECTS.filter(p => p.category === c.value).length})
              </button>
            ))}
          </div>

          {/* Galeri grid */}
          {filtered.length === 0 ? (
            <div className={styles.empty}>Bu kategoride henüz proje eklenmedi.</div>
          ) : (
            <div className={styles.grid}>
              {filtered.map((p, i) => (
                <div
                  key={i}
                  className={styles.card}
                  onClick={() => setLightbox(p)}
                >
                  <div className={styles.imageWrap}>
                    <img
                      src={`${process.env.PUBLIC_URL}/projects/${p.image}`}
                      alt={p.title}
                      className={styles.image}
                      loading="lazy"
                    />
                    <div className={styles.overlay}>
                      <span className={styles.zoomIcon}>🔍</span>
                    </div>
                    <span className={styles.badge}>{p.categoryLabel}</span>
                  </div>
                  <div className={styles.cardBody}>
                    <h3 className={styles.cardTitle}>{p.title}</h3>
                    <p className={styles.cardLocation}>📍 {p.location}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className={styles.lightboxOverlay} onClick={() => setLightbox(null)}>
          <button
            className={styles.lightboxClose}
            onClick={() => setLightbox(null)}
            aria-label="Kapat"
          >
            ✕
          </button>
          <div className={styles.lightboxContent} onClick={e => e.stopPropagation()}>
            <img
              src={`${process.env.PUBLIC_URL}/projects/${lightbox.image}`}
              alt={lightbox.title}
              className={styles.lightboxImage}
            />
            <div className={styles.lightboxInfo}>
              <span className={styles.lightboxBadge}>{lightbox.categoryLabel}</span>
              <h3 className={styles.lightboxTitle}>{lightbox.title}</h3>
              <p className={styles.lightboxLocation}>📍 {lightbox.location}</p>
              <p className={styles.lightboxDesc}>{lightbox.desc}</p>
            </div>
          </div>
        </div>
      )}

      <CtaBand
        title="Sizin projeniz de burada olabilir"
        sub="Asansör ihtiyaçlarınız için bugün bize ulaşın."
      />
    </main>
  );
}
